import { useEffect, useRef } from 'react'
import { Box, EmptyState, VStack } from '~/design_system'
import { useMsg } from '~/common/localizationUtils'
import { useChatContext } from '../ChatContext'
import { QuestionResponse } from './QuestionResponse'
import { SparkleSpinner } from './SparkleSpinner'
import { Welcome } from './Welcome'

export const ThreadContent = () => {
  const scrollRef = useRef<HTMLDivElement>(null)
  const thread = useChatContext()
  const itemCount = thread.threadItems.length
  const isLastItemPending = thread.threadItems.at(-1)?.isPending

  useEffect(() => {
    if (itemCount === 0) return
    requestAnimationFrame(() => {
      const element = scrollRef.current
      if (element) element.scrollTop = element.scrollHeight
    })
  }, [itemCount, isLastItemPending])

  return (
    <Box
      ref={scrollRef}
      height="100%"
      overflowY="auto"
      overflowX="hidden"
      px={5}
      py={6}
      sx={{
        '&::-webkit-scrollbar': {
          width: '6px'
        },
        '&::-webkit-scrollbar-track': {
          background: 'gray.100'
        },
        '&::-webkit-scrollbar-thumb': {
          background: 'gray.300',
          borderRadius: '3px'
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: 'gray.400'
        }
      }}>
      <VStack spacing={4} align="stretch">
        <ThreadBody />
      </VStack>
    </Box>
  )
}

const ThreadBody = () => {
  const msg = useMsg()
  const thread = useChatContext()

  if (thread.isThreadError) {
    return (
      <EmptyState>
        <EmptyState.RefreshError title={msg('assistant.ai.history.load_error')} onRefresh={thread.reloadThread} />
      </EmptyState>
    )
  }

  if (thread.threadItems.length === 0) {
    return thread.isThreadLoading ? (
      <Box display="flex" justifyContent="center" py={8}>
        <SparkleSpinner />
      </Box>
    ) : (
      <Welcome />
    )
  }

  return thread.threadItems.map(threadItem => <QuestionResponse key={threadItem.id} threadItem={threadItem} />)
}
